import Vue from 'vue'
import VueI18n from 'vue-i18n'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import axios from 'axios'
import { cacheAdapterEnhancer } from 'axios-extensions'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import VueCookie from 'vue-cookie'
import VueTabs from 'vue-nav-tabs'
import {Collapse, CollapseItem, Table} from 'element-ui'

// import StayAwake from './stayawake'
import NoSleep from './stayawake'
// import NoSleep from 'nosleep.js'

// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// mixins
import InmobitoMx from 'src/mixins/Inmobito'

// store
import store from './store/index'

// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './sidebarLinks'

import moment from 'moment'

// translates
import messages from './lang/lang'

// Wysiwyg editor
import wysiwyg from 'vue-wysiwyg'

import DataTables from 'vue-data-tables'

// plugin setup
Vue.use(DataTables)
Vue.use(VueTabs)
Vue.use(Table)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(VueI18n)
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
Vue.use(VueAxios, axios, cacheAdapterEnhancer)
locale.use(lang)
Vue.use(wysiwyg, {
  hideModules: { 'code': true, 'table': true },
  maxHeight: '500px'
})
Vue.use(VueSession, {persist: 1})
Vue.use(VueCookie)

Vue.mixin(InmobitoMx)

// --------------------------------------------------------------------
// configure router
// --------------------------------------------------------------------
// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en', // if the message does not exists show the english version
  messages // set locale messages
})

locale.i18n((key, value) => i18n.t(key, value))

const router = new VueRouter({
  i18n,
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

// keep awake the browser
// StayAwake.init()
// StayAwake.enable()
var noSleep = new NoSleep()
noSleep.enable()
// --------------------------------------------------------------------
// filters
// --------------------------------------------------------------------
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})
Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY H:mm')
  }
})
Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('H:mm')
  }
})

const EventBus = new Vue()

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.modal) {
    const matched = to.matched[to.matched.length - 1]
    const component = matched.components.default

    // Clonare route pentru props, fără __ob__
    const routeProps = {
      params: { ...to.params },
      query: { ...to.query },
      fullPath: to.fullPath,
      path: to.path,
      name: to.name
    }

    console.log('🟣 MODAL ROUTE DETECTED')
    console.log('📦 Modal component:', component)
    console.log('📨 Modal props (full route):', routeProps)

    EventBus.$emit('open-modal', {
      component,
      props: { route: routeProps }
    })

    // Oprește navigarea normală
    return next(false)
  }

  next()
})

router.beforeEach((to, from, next) => {
  const marketerRoutes = ['/customers', '/products', '/logout', '/customers', '/groups', '/marketing/campaigns',
    '/marketing/offers', '/marketing/dynamic-menus', '/marketing/fidelities', '/marketing/client-order-view',
    '/marketing/campaigns/edit/', '/marketing/coupons', '/categories', '/top-categories', '/product-option', '/product-filters', '/custom-info-pages',
    '/menu-links', '/info-pages', '/integrations/menu-fix']
  let matches = marketerRoutes.filter(
    s => {
      return to.path.includes(s)
    }
  )

  const operatorRoutes = ['/dashboard', '/logout', '/scanner']
  let operatorRoutesMatches = operatorRoutes.filter(
    s => {
      return to.path.includes(s)
    }
  )

  if (router.app.$session.get('userDataRole') === 'MARKETER') {
    if (!matches.length) {
      next('/products')
    } else {
      next()
    }
  } else {
    next()
  }

  if (router.app.$session.get('userDataRole') === 'OPERATOR') {
    if (!operatorRoutesMatches.length) {
      next('/scanner')
    } else {
      next()
    }
  } else {
    next()
  }
})

Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function () {
      return EventBus
    }
  }
})
// --------------------------------------------------------------------
/* eslint-disable no-new */
// --------------------------------------------------------------------
new Vue({
  el: '#app',
  render: h => h(App),
  i18n,
  router,
  store,
  created () {
    if (this.$session && this.$session.exists && this.$session.exists()) {
      this.initAuditClient()
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js